// Sends app crashes/errors to our own log (/api/ai?errlog=1). Max 15 per page load, same error once.
// Never sends what people typed - only the error message, where it happened and the page (no #hash, no secret in the query).
import { safeLogUrl } from './lib/logUrl'

const seen = new Set()
let sent = 0
const IGNORE = [/ResizeObserver loop/, /Loading chunk \d+ failed/, /AbortError/, /The user aborted a request/, /Script error\.?$/, /NetworkError when attempting to fetch/, /Failed to fetch/, /Load failed/]

function token() {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && /^sb-.*-auth-token$/.test(k)) { const v = JSON.parse(localStorage.getItem(k) || '{}'); return v.access_token || (v.currentSession && v.currentSession.access_token) || '' }
    }
  } catch (e) {}
  return ''
}

export function reportError(err, extra) {
  try {
    if (window.location.hostname === 'localhost') return
    const message = String((err && (err.message || err.reason)) || err || 'Unknown error').slice(0, 1000)
    if (IGNORE.some(r => r.test(message))) return
    const key = message + '|' + ((err && err.stack) || '').split('\n')[1]
    if (seen.has(key) || sent >= 15) return
    seen.add(key); sent++
    const t = token()
    fetch('/api/ai?errlog=1', {
      method: 'POST', keepalive: true,
      headers: Object.assign({ 'Content-Type': 'application/json' }, t ? { Authorization: 'Bearer ' + t } : {}),
      body: JSON.stringify({ message: extra ? message + ' [' + extra + ']' : message, stack: err && err.stack ? String(err.stack).slice(0, 4000) : null, url: safeLogUrl(window.location.pathname + window.location.search), release: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || '' }),
    }).catch(() => {})
  } catch (e) {}
}

window.addEventListener('error', e => reportError(e.error || e.message))
window.addEventListener('unhandledrejection', e => reportError(e.reason, 'promise'))
window.hcReportError = reportError
